import { render } from "./pembinaan.vue?vue&type=template&id=109f8323&scoped=true"
import script from "./pembinaan.vue?vue&type=script&lang=js"
export * from "./pembinaan.vue?vue&type=script&lang=js"

import "./pembinaan.vue?vue&type=style&index=0&id=109f8323&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-109f8323"

export default script